import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-orders-trip-view",
  templateUrl: "./orders-trip-view.component.html",
  styleUrls: ["./orders-trip-view.component.css"],
})
export class OrdersTripViewComponent implements OnInit {
  ordersView: any;
  taxData: any;
  tax: any;
  totalTax: any;
  taxDetails: any;
  paymentHistory: any;
  transporterHistory: any;
  Trip_History: any;
  finalFareAfterDeductions: number = 0;

  constructor(
    private matdialogref: MatDialogRef<OrdersTripViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  // ngOnInit(): void {
  //   this.ordersView = this.data;
  //   this.Trip_History = this.ordersView.trip_history;
  //   this.Trip_History = this.getLatestEntries(
  //     this.ordersView?.trip_history
  //   ).filter(
  //     (history) =>
  //       history.name !== "pod_submission" || history.is_verified === 1
  //   );

  //   if (this.ordersView?.userInfo?.user_type === "customer") {
  //     this.paymentHistory =
  //       this.ordersView.paymentInfo[0]?.price_details?.payment_history;
  //     let uniqueTaxDetails: any = [];
  //     let taxDetailsMap = new Map();

  //     this.ordersView.driverRouteInfo[0].tax_details.forEach(
  //       (taxDetail: any) => {
  //         const key = taxDetail.tax_name + taxDetail.tax_type;
  //         if (!taxDetailsMap.has(key)) {
  //           taxDetailsMap.set(key, true);
  //           uniqueTaxDetails.push(taxDetail);
  //         }
  //       }
  //     );

  //     this.taxDetails = uniqueTaxDetails;

  //     // Step 2: Perform calculations
  //     let totalTax = 0;
  //     let originalPrice = this.ordersView.driverRouteInfo[0].price;

  //     for (let i = 0; i < this.taxDetails.length; i++) {
  //       if (this.taxDetails[i].tax_type == "percent") {
  //         let taxData =
  //           (originalPrice * this.taxDetails[i].tax_deduction) / 100;
  //         totalTax += taxData;
  //       } else {
  //         totalTax += this.taxDetails[i].tax_deduction;
  //       }
  //     }

  //     this.totalTax = Math.round(originalPrice - totalTax);
  //   }

  //   this.transporterHistory = this.ordersView.truckownerPaymentInfo;
  // }

  ngOnInit(): void {
    this.ordersView = this.data;

    this.Trip_History = this.getLatestEntries(
      this.ordersView?.trip_history
    ).filter(
      (history) =>
        history?.is_verified !== 0
    );

    if (this.ordersView?.userInfo?.user_type === "customer") {
      this.paymentHistory =
        this.ordersView.paymentInfo[0]?.price_details?.payment_history;

      // Get tax details from paymentInfo
      const priceDetails = this.ordersView.paymentInfo[0]?.price_details;
      const taxDetails = priceDetails?.transporter_tax_details || [];
      this.taxDetails = taxDetails;

      const originalPrice = Number(priceDetails?.actual_price || 0);
      let totalDeductions = 0;

      for (const tax of taxDetails) {
        const value = Number(tax.tax_deduction || 0);
        if (tax.tax_type === 'percent') {
          const deduction = (originalPrice * value) / 100;
          totalDeductions += deduction;
        } else {
          totalDeductions += value;
        }
      }

      const final = originalPrice - totalDeductions;
      this.finalFareAfterDeductions = isFinite(final) ? final : 0;
    }
    this.transporterHistory = this.ordersView.truckownerPaymentInfo;
  }

  private getLatestEntries(data: any[]): any[] {
    const latestEntries = new Map<string, any>();

    data.forEach((item) => {
      const existing = latestEntries.get(item.name);
      if (!existing || new Date(item.date) > new Date(existing.date)) {
        latestEntries.set(item.name, item);
      }
    });

    return Array.from(latestEntries.values());
  }

  close() {
    this.matdialogref.close();
  }

  consignment(item: any) {
    window.open(item.consignment_details?.consignment_url);
  }
}
